export const SET_APPLICATION_STATUS = 'SET_APPLICATION_STATUS';
export const SET_APPLICATION_PAYLOAD = 'SET_APPLICATION_PAYLOAD';
export const SET_LANDING_PAGE_DATA = 'SET_LANDING_PAGE_DATA';
export const SET_LOAN_AMOUNT = 'SET_LOAN_AMOUNT';
